class CompanyBranch {
  constructor(branchData = {}) {
    this.id = branchData.id || null;
    this.branchCode = branchData.code || "";
    this.companyId = branchData.companyId || null;    
  };
};
  
export default CompanyBranch;
  